import React, { useState } from "react";
import { MdOutlineSettingsApplications } from "react-icons/md";
import "./CardFase.css";

import FullScreenGrupos from "../../FullScreenModal/FullScreenGrupos/FullScreenGrupos";
import FullScreenEliminatoria from "../../FullScreenModal/FullScreenEliminatoria/FullScreenEliminatoria";

import ModalConfigPrimeraFase from "../../Modals/ModalConfigPrimeraFase/ModalConfigPrimeraFase";
import ModalConfigFaseFinal from "../../Modals/ModalConfigFaseFinal/ModalConfigFaseFinal";

const CardFase = ({ phase }) => {
  const [openGrupos, setOpenGrupos] = useState(false);
  const [openEliminatoria, setOpenEliminatoria] = useState(false);
  const [openConfigPrimeraFase, setOpenConfigPrimeraFase] = useState(false);
  const [openConfigFaseFinal, setOpenConfigFaseFinal] = useState(false);

  const [tipoFase, setTipoFase] = useState(null);

  const handleOpenModal = (idtypephase) => {
    idtypephase === 1 ? setOpenGrupos(true) : setOpenEliminatoria(true);
  };

  const handleOpenConfig = (idtypephase) => {
    setTipoFase(idtypephase);
    (idtypephase === 1 || idtypephase === 2)
      ? setOpenConfigPrimeraFase(true)
      : setOpenConfigFaseFinal(true);
  };

  return (
    <>
      <div className="relative w-full p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 font-quickSand">
        <a href="#">
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
            {phase && phase.tag.toUpperCase()}
          </h5>
        </a>
        <p className="mb-3 font-normal text-gray-700 dark:text-gray-400">
          {phase && phase.typephase.description}
        </p>
        <a
          className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 cursor-pointer"
          onClick={() => handleOpenModal(phase.idtypephase)}
        >
          Ingresar
          <svg
            className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 5h12m0 0L9 1m4 4L9 9"
            />
          </svg>
        </a>
        <MdOutlineSettingsApplications
          className="absolute top-4 right-4 text-gray-700 dark:text-gray-300 cursor-pointer spin-hover"
          size={24}
          onClick={() => handleOpenConfig(phase.idtypephase)}
        />
      </div>
      {openGrupos ? (
        <FullScreenGrupos open={openGrupos} setOpen={setOpenGrupos} />
      ) : null}
      {openEliminatoria ? (
        <FullScreenEliminatoria
          open={openEliminatoria}
          setOpen={setOpenEliminatoria}
        />
      ) : null}
      {openConfigPrimeraFase ? (
        <ModalConfigPrimeraFase
          open={openConfigPrimeraFase}
          setOpen={setOpenConfigPrimeraFase}
          tipoFase={tipoFase}
        />
      ) : null}
    </>
  );
};

export default CardFase;
